import axios from 'axios';
import { IDataTableQueryFnParams } from 'src/components/DataTable/shared/types';
import { vendorUrlRegexPath, withPimURL } from 'src/helpers/service';
import { IAcceptedFlashProductListResponse } from '../models/flash-discount';

export const getAcceptedFlashProductsQueryKey = () => {
  return ['accepted-flash-products'];
};

export const getAcceptedFlashProducts = async (params: IDataTableQueryFnParams) => {
  const { filters, pagination } = params;

  return axios
    .get<IAcceptedFlashProductListResponse>(withPimURL(vendorUrlRegexPath('/flash-discount/:vendorId/accepted-products')), {
      params: {
        ...filters,
        page: pagination.pageIndex,
        limit: pagination.pageSize,
      },
    })
    .then((res) => res.data)
    .then((res) => ({
      ...res,
      items: res.items.map((item) => ({
        ...item,
        _rowId: `accepted-flash-product-${item.id}${Array.isArray(item.periodInfo) ? item.periodInfo?.map((e: any) => e.id).join('-') : ''}`,
      })),
    }));
};
